import { getAxiosInstance } from '../client';
/** Typed API functions for legal documents */
export const legalDocumentsQueries = {
    /** GET /legal-documents with document type parameter */
    getDocument: (document) => getAxiosInstance()
        .get('/legal-documents', { params: { document } })
        .then((r) => r.data),
    /** GET /legal-documents/:document?docx=true - Download as DOCX */
    downloadDocument: (document) => getAxiosInstance()
        .get(`/legal-documents/${document}`, {
        params: { docx: true },
        responseType: 'arraybuffer',
    })
        .then((r) => ({
        data: r.data,
        headers: r.headers,
    })),
    /** GET /legal-documents/pending — what the Person of the Active office still has to accept (#1824). */
    getPending: () => getAxiosInstance()
        .get('/legal-documents/pending')
        .then((r) => r.data),
};
/** Query keys for legal documents - use with TanStack Query */
export const legalDocumentsKeys = {
    all: () => ['legal-documents'],
    document: (document) => ['legal-documents', document],
    pending: () => ['legal-documents', 'pending'],
};
//# sourceMappingURL=legal-documents.queries.js.map